/**
 * mc-collection.js — Manifesto
 *
 * Interatividade COMPARTILHADA do catálogo (sections/main-collection-manifesto)
 * e da busca (sections/main-search-manifesto) — task 0018 / DP-4. A raiz é
 * qualquer nó com [data-mc-catalog] (busca) ou o data-section-type do catálogo
 * (hook antigo preservado); toda a lógica abaixo é relativa a esse nó.
 *
 * Não depende do facets.js do Dawn — os filtros são nativos por URL param
 * (GET form). Aqui cuidamos de:
 *   1. Accordions dos FilterBlocks.
 *   2. Auto-submit do form de filtros no desktop (change em checkbox/preço).
 *   3. Sort (preserva filtros, navega com ?sort_by=).
 *   4. Overlay de filtros no mobile (abrir/fechar + lock de body); "Aplicar"
 *      é submit nativo do form mobile.
 *   5. Busca client-side sobre os cards já renderizados (espelha o React).
 *   6. "Ver mais" — fetch da próxima página e append no grid.
 */

(function () {
  'use strict';

  function init() {
    // Raízes suportadas: busca ([data-mc-catalog]) e catálogo (hook legado).
    var roots = document.querySelectorAll(
      '[data-mc-catalog], [data-section-type="main-collection-manifesto"]'
    );
    Array.prototype.forEach.call(roots, initRoot);
  }

  function initRoot(section) {
    if (!section || section.hasAttribute('data-mc-inited')) return;
    section.setAttribute('data-mc-inited', '');

    // 1. Accordions
    section.querySelectorAll('[data-mc-acc]').forEach(function (head) {
      head.addEventListener('click', function () {
        var block = head.closest('[data-mc-acc-block]');
        if (!block) return;
        var collapsed = block.hasAttribute('data-collapsed');
        if (collapsed) {
          block.removeAttribute('data-collapsed');
          head.setAttribute('aria-expanded', 'true');
        } else {
          block.setAttribute('data-collapsed', '');
          head.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // 2. Auto-submit (desktop)
    var deskForm = section.querySelector('[data-mc-filter-form]');
    if (deskForm) {
      deskForm.addEventListener('change', function (e) {
        if (e.target.matches('[data-mc-filter-input]')) {
          deskForm.submit();
        }
      });
    }

    // 2b. Slider de preço — dois controles (mín + máx), valores em reais
    function brl(v) { return 'R$ ' + Number(v).toLocaleString('pt-BR'); }
    section.querySelectorAll('[data-mc-price]').forEach(function (box) {
      var minI = box.querySelector('[data-mc-price-min]');
      var maxI = box.querySelector('[data-mc-price-max]');
      var fill = box.querySelector('[data-mc-price-fill]');
      var minL = box.querySelector('[data-mc-price-min-label]');
      var maxL = box.querySelector('[data-mc-price-max-label]');
      var floor = parseInt(box.getAttribute('data-floor'), 10) || 1;
      if (!minI || !maxI) return;

      function render() {
        var lo = parseInt(minI.value, 10) || 0;
        var hi = parseInt(maxI.value, 10) || floor;
        // impede cruzamento dos thumbs
        if (lo > hi) {
          if (document.activeElement === minI) { lo = hi; minI.value = lo; }
          else { hi = lo; maxI.value = hi; }
        }
        if (fill) {
          fill.style.left = (lo / floor) * 100 + '%';
          fill.style.right = (100 - (hi / floor) * 100) + '%';
        }
        if (minL) minL.textContent = brl(lo);
        if (maxL) maxL.textContent = brl(hi);
      }
      minI.addEventListener('input', render);
      maxI.addEventListener('input', render);
      render();
    });

    // 3. Sort
    function applySort(value) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
    section.querySelectorAll('[data-mc-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () { applySort(sel.value); });
    });

    // 4. Overlay mobile
    var overlay = section.querySelector('[data-mc-overlay]');
    var openers = section.querySelectorAll('[data-mc-filters-open]');
    var closers = section.querySelectorAll('[data-mc-filters-close]');
    function openOverlay() {
      if (!overlay) return;
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }
    function closeOverlay() {
      if (!overlay) return;
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    openers.forEach(function (b) { b.addEventListener('click', openOverlay); });
    closers.forEach(function (b) { b.addEventListener('click', closeOverlay); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && !overlay.hasAttribute('hidden')) closeOverlay();
    });

    // 5. Busca client-side
    var grid = section.querySelector('[data-mc-grid]');
    var noResults = section.querySelector('[data-mc-no-results]');
    var searchInputs = section.querySelectorAll('[data-mc-search]');
    function applySearch(term) {
      if (!grid) return;
      var q = (term || '').trim().toLowerCase();
      var visible = 0;
      grid.querySelectorAll('[data-mc-card]').forEach(function (cell) {
        var hay = (cell.getAttribute('data-title') || '') + ' ' + (cell.getAttribute('data-vendor') || '');
        var show = q.length < 2 || hay.indexOf(q) !== -1;
        cell.hidden = !show;
        if (show) visible++;
      });
      if (noResults) noResults.hidden = !(q.length >= 2 && visible === 0);
      // mantém os dois inputs sincronizados
      searchInputs.forEach(function (i) { if (i.value !== term) i.value = term; });
    }
    searchInputs.forEach(function (input) {
      input.addEventListener('input', function () { applySearch(input.value); });
    });

    // 6. Ver mais (load-more)
    var moreBtn = section.querySelector('[data-mc-load-more]');
    var showing = section.querySelector('[data-mc-showing]');
    if (moreBtn && grid) {
      moreBtn.addEventListener('click', function () {
        var nextUrl = moreBtn.getAttribute('data-next-url');
        if (!nextUrl) return;
        moreBtn.disabled = true;
        moreBtn.textContent = 'CARREGANDO…';
        fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-mc-grid]');
            if (newGrid) {
              Array.prototype.forEach.call(newGrid.children, function (li) {
                grid.appendChild(li.cloneNode(true));
              });
            }
            var newBtn = doc.querySelector('[data-mc-load-more]');
            var newShowing = doc.querySelector('[data-mc-showing]');
            if (newShowing && showing) showing.textContent = newShowing.textContent;
            if (newBtn) {
              moreBtn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
              moreBtn.disabled = false;
              moreBtn.textContent = '+ VER MAIS CERVEJAS';
            } else {
              moreBtn.remove();
            }
            // reaplica busca aos cards novos
            var active = section.querySelector('[data-mc-search]');
            if (active && active.value) applySearch(active.value);
          })
          .catch(function () {
            moreBtn.disabled = false;
            moreBtn.textContent = '+ VER MAIS CERVEJAS';
          });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
